const townAlternativeNames = [
  { townName: 'welwyn garden city', alternatives: ['welwyn'] },
  { townName: 'erdington', alternatives: ['kingstanding'] },
  { townName: 'midsomer norton', alternatives: ['paulton'] },
];

const townNamesMatch = (town1, town2) => {
  if (sanitizeTownName(town1) === sanitizeTownName(town2)) return true;

  const town1Lower = town1.toLowerCase();
  const town2Lower = town2.toLowerCase();

  for (const i in townAlternativeNames) {
    const town = townAlternativeNames[i];
    if (
      (town1Lower === town.townName &&
        town.alternatives.some((alternative) => town2Lower === alternative)) ||
      (town2Lower === town.townName &&
        town.alternatives.some((alternative) => town1Lower === alternative))
    )
      return true;
  }

  return false;
};

// Let the record show I hate this but there grecaptcha.ready() doesn't return a promise
// so a poll-loop is the only way I can figure out to wait for a result
const doRecaptchaAction = async (func, action) => {
  let result = undefined;
  let ready = false;

  waitFor(() => typeof grecaptcha !== 'undefined').then(async () => {
    grecaptcha.ready(() => {
      grecaptcha
        .execute(process.env.GATSBY_RECAPTCHA_SECRET_KEY, {
          action,
        })
        .then((token) => {
          result = func(token);
          ready = true;
        });
    });
  });

  await waitFor(() => ready);
  return result;
};

const sanitizeTownName = (town) => {
  return town.toLowerCase().replaceAll('-', ' ');
};

const waitFor = (func) => {
  const poll = (resolve) => {
    if (func()) resolve();
    else setTimeout(() => poll(resolve), 20);
  };

  return new Promise(poll);
};

const formatTermsSlug = (slug) => {
  return slug.toLowerCase().replace(/\s/g, '');
};

const getCurrency = (value) => {
  if (value >= 0) return '£' + value.toFixed(2);
  return '-£' + Math.abs(value).toFixed(2);
};

const capitalFirstLetter = (string) => {
  return string?.charAt(0).toUpperCase() + string?.slice(1);
};

const base64toBlob = (base64Data) => {
  const sliceSize = 1024;
  const byteCharacters = atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: 'application/pdf' });
};

const isIOS = () => {
  if (typeof window !== 'undefined') {
    const isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
    const isAppleDevice = window.navigator.userAgent.includes('Macintosh');
    const isTouchScreen = window.navigator.maxTouchPoints >= 1;
    return isIOS || (isAppleDevice && isTouchScreen);
  }
};

module.exports.getCurrency = getCurrency;
module.exports.formatTermsSlug = formatTermsSlug;
module.exports.doRecaptchaAction = doRecaptchaAction;
module.exports.townNamesMatch = townNamesMatch;
module.exports.capitalFirstLetter = capitalFirstLetter;
module.exports.base64toBlob = base64toBlob;
module.exports.isIOS = isIOS;
